import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const mediaProgressSlice = createSlice({
   name: 'mediaProgressData',
   initialState,
   reducers: {
      setProgress: (state, action) => {
         const { msgId } = action.payload;
         state[msgId] = action.payload;
      },
      deleteProgress: (state, action) => {
         const { msgId } = action.payload;
         if (state[msgId]) {
            delete state[msgId];
         }
      },
   },
});

export const { setProgress, deleteProgress } = mediaProgressSlice.actions;
export const mediaProgressReducer = mediaProgressSlice.reducer;
